import { render } from "./SimpleTextLabelRow.vue?vue&type=template&id=9d72f8f8&scoped=true"
import script from "./SimpleTextLabelRow.vue?vue&type=script&lang=js"
export * from "./SimpleTextLabelRow.vue?vue&type=script&lang=js"

import "./SimpleTextLabelRow.vue?vue&type=style&index=0&id=9d72f8f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9d72f8f8"]])

export default __exports__